import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FeaturedCategories() {
  return (
    <section className="py-16 md:py-24 bg-background-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-100 mb-4">探索夜间世界</h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            四个维度，带你深入夜晚的每一个角落，发现属于你的夜间生活
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-900 border border-background-800/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={category.imageUrl}
                  alt={category.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900 via-background-900/30 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-5 relative">
                <div className="flex items-center gap-3 mb-2">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/15">
                    <i className={`${category.icon} text-primary-400 text-lg`}></i>
                  </span>
                  <h3 className="font-heading text-lg text-foreground-100 group-hover:text-primary-400 transition-colors duration-200">
                    {category.name}
                  </h3>
                </div>
                <p className="text-foreground-500 text-sm leading-relaxed mb-3 line-clamp-2">
                  {category.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-600">{category.articleCount} 篇文章</span>
                  <span className="text-primary-400 text-sm flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    浏览 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}